/**
 * Formats a duration in seconds to a human readable format
 *
 * If under 1 hour then it will be formatted as `minutes`m `seconds`s
 * If over 1 hour (or equal to) then it will be formatted as `hours`h `minutes`m
 * If over or equal to 24 hours then it will be formatted as `days`d `hours`h
 *
 *
 * @param duration Duration in seconds
 * @returns
 */
export function formatDuration(duration: number) {
    const days = Math.floor(duration / 86400)
    const hours = Math.floor(duration / 3600)
    const minutes = Math.floor((duration % 3600) / 60)
    const seconds = Math.floor(duration % 60)

    if (days >= 1) {
        return `${days}d ${hours}h`
    } else if (hours >= 1) {
        return `${hours}h ${minutes}m`
    } else {
        return `${minutes}m ${seconds}s`
    }
}

export function formatDurationPlain(duration: number) {
    const hours = Math.floor(duration / 3600)
    const minutes = Math.floor((duration % 3600) / 60)
    const seconds = Math.floor(duration % 60)

    return `${hours}:${minutes}:${seconds}`
}
